"use strict";

var _regeneratorRuntime = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/nightmail/Documents/SourceCode/codb.io/web/node_modules/@babel/runtime/helpers/asyncToGenerator");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var lodash_1 = __importDefault(require("lodash"));

var remote_items_filter_1 = __importDefault(require("../constants/actions/remote-items-filter"));

var UtilsArray = __importStar(require("../utils/array"));

var UtilsFilter = __importStar(require("../utils/filter"));

var UtilsRemoteGroup = __importStar(require("../utils/remote-group"));

var UtilsRemoteItem = __importStar(require("../utils/remote-item"));

function init() {
  return (
    /*#__PURE__*/
    function () {
      var _ref = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(dispatch, getState) {
        var state, remoteItems, remoteItemsFilter, group, items, groupedOpts, metas, focus_meta, options, selected, user_inputs, user_input, current_user_input;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch({
                  type: remote_items_filter_1.default.GET_DATA_INIT
                });
                state = getState();
                remoteItems = state.remoteItems, remoteItemsFilter = state.remoteItemsFilter;
                group = remoteItems.group;
                _context.next = 6;
                return UtilsRemoteItem.getItemsByGroupId({
                  groupId: group.id,
                  isOnlyMine: false,
                  isReload: false
                });

              case 6:
                items = _context.sent;
                groupedOpts = UtilsFilter.sortOptions(UtilsRemoteGroup.getFilterData(group, items));
                metas = groupedOpts.map(function (u) {
                  return u.meta;
                });
                focus_meta = metas.length >= 1 ? metas[0] : null;
                options = UtilsFilter.sortOptionList(groupedOpts.length >= 1 ? groupedOpts[0].list : [], focus_meta);
                selected = remoteItemsFilter.selected;
                user_inputs = remoteItemsFilter.user_inputs;
                user_input = lodash_1.default.find(user_inputs, function (u) {
                  return lodash_1.default.isEqual(u.meta, focus_meta);
                });
                current_user_input = !!user_input ? user_input : null;
                dispatch({
                  type: remote_items_filter_1.default.GET_DATA_SUCCESS,
                  grouped_options: groupedOpts,
                  options: options,
                  selected: selected,
                  user_inputs: user_inputs,
                  current_user_input: current_user_input,
                  metas: metas,
                  focus_meta: focus_meta,
                  filled_metas: UtilsFilter.unionSelectedMetas(selected, user_inputs),
                  items: items
                });

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }()
  );
}

exports.init = init;

function confirm() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(dispatch, getState) {
        var state, selected, user_inputs;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                dispatch({
                  type: remote_items_filter_1.default.CONFIRM_INIT
                });
                state = getState();
                selected = state.remoteItemsFilter.selected;
                user_inputs = state.remoteItemsFilter.user_inputs;

                try {
                  dispatch({
                    type: remote_items_filter_1.default.CONFIRM_SUCCESS,
                    selected: selected,
                    user_inputs: user_inputs
                  });
                } catch (error) {
                  dispatch({
                    type: remote_items_filter_1.default.CONFIRM_FAILURE,
                    error: error
                  });
                }

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function (_x3, _x4) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}

exports.confirm = confirm;

function reset() {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_filter_1.default.RESET
    });
  };
}

exports.reset = reset;

function clear() {
  return function (dispatch, getState) {
    dispatch({
      type: remote_items_filter_1.default.CLEAR
    });
  };
}

exports.clear = clear;

function select(meta, option, compare) {
  var must = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return function (dispatch, getState) {
    var state = getState().remoteItemsFilter;
    var selected = state.selected;
    var user_inputs = state.user_inputs;
    var newSelected = lodash_1.default.reject(selected, function (u) {
      return lodash_1.default.isEqual(u.meta, meta) && lodash_1.default.isEqual(u.option, option);
    });
    newSelected.push({
      meta: meta,
      option: option,
      compare: compare,
      must: must
    });
    dispatch({
      type: remote_items_filter_1.default.SELECT,
      selected: newSelected,
      filled_metas: UtilsFilter.unionSelectedMetas(newSelected, user_inputs)
    });
  };
}

exports.select = select;

function unselect(meta, option) {
  return function (dispatch, getState) {
    var state = getState().remoteItemsFilter;
    var selected = state.selected;
    var user_inputs = state.user_inputs;
    var newSelected = lodash_1.default.reject(selected, function (u) {
      return lodash_1.default.isEqual(u.meta, meta) && lodash_1.default.isEqual(u.option, option);
    });
    dispatch({
      type: remote_items_filter_1.default.SELECT,
      selected: newSelected,
      filled_metas: UtilsFilter.unionSelectedMetas(newSelected, user_inputs)
    });
  };
}

exports.unselect = unselect;

function changeUserInput(meta, changedUserInput) {
  return function (dispatch, getState) {
    var state = getState().remoteItemsFilter;
    var selected = state.selected,
        user_inputs = state.user_inputs;
    var userInputs;

    if (changedUserInput === null) {
      userInputs = lodash_1.default.filter(user_inputs, function (u) {
        return !lodash_1.default.isEqual(u.meta, meta);
      });
    } else {
      userInputs = UtilsArray.replaceByPropsOrAddIfNotExist(user_inputs, {
        meta: meta
      }, changedUserInput);
    }

    dispatch({
      type: remote_items_filter_1.default.CHANGE_USER_INPUT_SUCCESS,
      current_user_input: changedUserInput,
      user_inputs: userInputs,
      filled_metas: UtilsFilter.unionSelectedMetas(selected, userInputs)
    });
  };
}

exports.changeUserInput = changeUserInput;

function navigate(meta) {
  return function (dispatch, getState) {
    var state = getState().remoteItemsFilter;
    var groupedOpts = state.grouped_options;
    var opts = lodash_1.default.find(groupedOpts, function (u) {
      return lodash_1.default.isEqual(u.meta, meta);
    });
    var options = !!opts ? opts.list : [];
    options = UtilsFilter.sortOptionList(options, meta);
    var user_inputs = state.user_inputs;
    var user_input = lodash_1.default.find(user_inputs, function (u) {
      return lodash_1.default.isEqual(u.meta, meta);
    });
    var current_user_input = !!user_input ? user_input : null;
    dispatch({
      type: remote_items_filter_1.default.NAVIGATE,
      focus_meta: meta,
      options: options,
      current_user_input: current_user_input
    });
  };
}

exports.navigate = navigate;